import { ActionTree } from 'vuex';
import TollDomainService from '@/services/tolldomain.service';
import { DatRelatedV3 } from 'ctp-toll-domain';
import { FETCH_DATS, CREATE_DAT, CREATE_DAT_VERSION, ARCHIVE_DAT, DELETE_DAT, EDIT_DAT, EDIT_DAT_VERSION, UPDATE_DATS_STATE, DELETE_VERSION, SET_ERROR, SET_NOTIFICATION, DatsState } from './types';
import { DatsApiCaller as DatsApi } from './caller';

const actions: ActionTree<DatsState, Record<string, never>> = {
  async [FETCH_DATS]({ commit }, master): Promise<void> {
    commit(UPDATE_DATS_STATE, {
      view: 'files',
      stateKey: 'loading',
      stateValue: true
    });
    commit(UPDATE_DATS_STATE, {
      view: 'files',
      stateKey: 'fetched',
      stateValue: false
    });
    commit(UPDATE_DATS_STATE, {
      view: 'files',
      stateKey: 'error',
      stateValue: false
    });
    return DatsApi.getDatsV3(master.id)
      .then((res) => {
        res.forEach((dat) => {
          dat.datVersions?.sort((datVersionA, datVersionB) => datVersionB.validFrom - datVersionA.validFrom);
        });
        commit(FETCH_DATS, res);
        commit(UPDATE_DATS_STATE, {
          view: 'dats',
          stateKey: 'fetched',
          stateValue: true
        });
        commit(UPDATE_DATS_STATE, {
          view: 'dats',
          stateKey: 'loading',
          stateValue: false
        });
        commit(UPDATE_DATS_STATE, {
          view: 'dats',
          stateKey: 'error',
          stateValue: false
        });
      })
      .catch((res) => {
        commit(SET_ERROR, res.message);
        commit(UPDATE_DATS_STATE, {
          view: 'dats',
          stateKey: 'error',
          stateValue: true
        });
        commit(UPDATE_DATS_STATE, {
          view: 'dats',
          stateKey: 'fetched',
          stateValue: false
        });
        commit(UPDATE_DATS_STATE, {
          view: 'dats',
          stateKey: 'loading',
          stateValue: false
        });
      });
  },
  // SWAGGER CODEGEN BUG - multipart not supported for file upload
  [CREATE_DAT]({ commit }, payload): Promise<void> {
    return TollDomainService.createDat(payload).then((response: Response) => {
      if (response.ok) {
        commit(SET_NOTIFICATION, {
          notificationStatus: 'success', code: 200, content: 'map.tolldomains.dats.created'
        });
      } else {
        response.text().then((text) => {
          const res = JSON.parse(text);
          const content = res.code ? `common.error.${res.code}` : res;
          commit(SET_NOTIFICATION, {
            notificationStatus: 'error', code: response.status, content, field: res.message
          });
        });
      }
    });
  },
  // SWAGGER CODEGEN BUG - multipart not supported for file upload
  [CREATE_DAT_VERSION]({ commit }, payload): Promise<void> {
    return TollDomainService.createDatVersion(payload.datId, payload.fileData).then((response: Response) => {
      if (response.ok) {
        commit(SET_NOTIFICATION, {
          notificationStatus: 'success', code: 200, content: 'map.tolldomains.dats.created_version'
        });
      } else {
        response.text().then((text) => {
          const res = JSON.parse(text);
          const content = res.code ? `common.error.${res.code}` : res;
          commit(SET_NOTIFICATION, {
            notificationStatus: 'error', code: response.status, content, field: res.message
          });
        });
      }
    });
  },
  [ARCHIVE_DAT]({ commit }, dat: DatRelatedV3): Promise<void> {
    return DatsApi.deleteDat(dat.id, true)
      .then((res) => {
        if (res.ok) {
          commit(SET_NOTIFICATION, {
            notificationStatus: 'success', code: res.status, content: 'map.tolldomains.dats.archived'
          });
        }
      })
      .catch((res) => {
        commit(SET_NOTIFICATION, {
          notificationStatus: 'error', code: res.status, content: 'map.tolldomains.dats.error_archiving'
        });
      });
  },
  [DELETE_DAT]({ commit }, dat: DatRelatedV3): Promise<void> {
    return DatsApi.deleteDat(dat.id, false)
      .then((res) => {
        if (res.ok) {
          commit(SET_NOTIFICATION, {
            notificationStatus: 'success', code: res.status, content: 'map.tolldomains.dats.deleted'
          });
        }
      })
      .catch((res) => {
        commit(SET_NOTIFICATION, {
          notificationStatus: 'error', code: res.status, content: 'map.tolldomains.dats.error_deleting'
        });
      });
  },
  [EDIT_DAT]({ commit }, payload): Promise<void> {
    return DatsApi.updateDat(payload.id, payload.body)
      .then((res) => {
        if (res) {
          commit(SET_NOTIFICATION, {
            notificationStatus: 'success', code: 200, content: 'map.tolldomains.dats.edited'
          });
        }
      })
      .catch((res) => {
        commit(SET_NOTIFICATION, {
          notificationStatus: 'error', code: res.status, content: 'map.tolldomains.dats.error_editing'
        });
      });
  },
  [EDIT_DAT_VERSION]({ commit }, payload): Promise<void> {
    return DatsApi.updateDatVersionV2(payload.datID, payload.versionID, payload.body)
      .then((res) => {
        if (res) {
          commit(SET_NOTIFICATION, {
            notificationStatus: 'success', code: 200, content: 'map.tolldomains.dats.edited'
          });
        }
      })
      .catch((res) => {
        commit(SET_NOTIFICATION, {
          notificationStatus: 'error', code: res.status, content: 'map.tolldomains.dats.error_editing'
        });
      });
  },
  [DELETE_VERSION]({ commit }, payload): Promise<void> {
    return DatsApi.deleteDatVersion(payload.datID, payload.versionID)
      .then((res) => {
        if (res.ok) {
          commit(SET_NOTIFICATION, {
            notificationStatus: 'success', code: res.status, content: 'map.tolldomains.dats.version_deleted'
          });
        }
      })
      .catch((res) => {
        commit(SET_NOTIFICATION, {
          notificationStatus: 'error', code: res.status, content: 'map.tolldomains.dats.error_deleting_version'
        });
      });
  }
};
export default actions;
